import { Component, input, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { HlmTooltipTrigger } from '@spartan-ng/helm/tooltip';

import { Outil } from './barre-d-outil/barre-d-outil.component';

@Component({
  selector: 'app-legende-item',
  template: `
    <button
      class="legende cursor-pointer"
      [class.disabled-button]="isDisabled()"
      [disabled]="isDisabled()"
      [hlmTooltipTrigger]="tooltipMessage()"
      (click)="onClickHandler()"
      position="right"
      type="button"
    >
      <ng-icon [name]="icon()" />
    </button>
  `,
  imports: [NgIcon, HlmTooltipTrigger],
  styleUrl: './barre-d-outil/barre-d-outil.component.scss',
})
export class LegendeItemComponent {
  readonly previewLabel = input.required<string>();
  readonly icon = input.required<string>();
  readonly fData = input.required<Outil>();
  readonly isDisabled = input<boolean>(false);
  readonly disableMessage = input<string | null>(null);
  readonly tooltipMessage = input.required<string>();

  readonly onClick = output<Outil>();

  onClickHandler() {
    this.onClick.emit(this.fData());
  }
}
